import './index.less';

import CheckIcon from '@/components/Common/Icons/svg/check.svg';
import CloseIcon from '@/components/Common/Icons/svg/close.svg';

const YesIcon = () => {
  return <CheckIcon className="compare-icon yes" />;
};

const NoIcon = () => {
  return <CloseIcon className="compare-icon no" />;
};

const CompareTable = () => {
  return (
    <div className="compare-table-section">
      <h2 id="compare-table-title" className="compare-table-section-title">
        Compare all plan features
      </h2>
      <div className="compare-table-section-wrapper">
        <table className="compare-table-section-table">
          <tr className="col-title-label">
            <th></th>
            <th></th>
            <th className="most-popular">Most popular</th>
            <th></th>
          </tr>
          <tr className="col-title">
            <th></th>
            <th className="essential">Essentials</th>
            <th className="business">Business</th>
            <th className="plus">Plus</th>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th className="pricing">Pricing</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>Pay monthly</th>
            <td>$39 USD / mo</td>
            <td>$199 USD / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>Pay yearly</th>
            <td>$29 USD / mo</td>
            <td>$149 USD / mo</td>
            <td>-</td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Pietra Platform</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>
              <div className="product-name">Team accounts</div> Invite your team members to easily collaborate
            </th>
            <td>
              <NoIcon />
            </td>
            <td>5</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Support channels</div> Access to Pietra's team of e-commerce experts
            </th>
            <td>Live chat & email</td>
            <td>Phone, priority live chat & email</td>
            <td>Dedicated account manager</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">AI Business Partner</div> An AI to automate & streamline daily operations
            </th>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Pietra Rewards</div> Earn at least 1% back from sourcing and more
            </th>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Sourcing & Production</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>
              <div className="product-name">Design Studio</div> Use AI to design production-ready products.
            </th>
            <td>500 designs / mo</td>
            <td>5,000 designs / mo</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Global Sourcing Network</div> Contact & work directly with the world's best
              factories
            </th>
            <td>Unlimited projects</td>
            <td>Unlimited projects</td>
            <td>Unlimited projects</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Connect your own suppliers</div>
              Centralize communication, POs & assets in one platform
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Factored Quality</div> Quality control & compliance operations platform
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr>
            <th>
              <div className="product-name">White glove sourcing services</div> End-to-end sourcing & production project
              management
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Sales & Marketing</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>
              <div className="product-name">Pietra Pulse</div>
              Monitor your brand, customers & competitors in one place
            </th>
            <td>
              750 posts/mo + <br />
              50 comments/video
            </td>
            <td>
              3000 posts/mo + <br />
              200 comments/video
            </td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Content Studio</div>
              Create e-commerce marketing assets
            </th>
            <td>Up to 1,000 images</td>
            <td>Up to 7,000 images</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">Affiliate & Influencer Management</div>
              Sign up influencers & manage commission payments
            </th>
            <td>10 affiliates tracked</td>
            <td>100 affiliates tracked</td>
            <td>Custom</td>
          </tr>
          <tr>
            <th>
              <div className="product-name">PR Box Service</div>
              Create & ship custom PR box campaigns
            </th>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
          <tr className="compare-table-section-table-row-title">
            <th>Print on Demand </th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>Print on Demand projects</th>
            <td>Unlimited</td>
            <td>Unlimited</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <th>White glove e-commerce team for support</th>
            <td>
              <NoIcon />
            </td>
            <td>
              <NoIcon />
            </td>
            <td>
              <YesIcon />
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default CompareTable;
